// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__kq5IX","img":"card_img__uY4Xw","brand":"card_brand__Y3_Pk","price":"card_price__NpUj0","virtualImage":"card_virtualImage__cg7D6"};